/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ColumnRangeParser = /* #__PURE__ */ parsers.object([
    ['start', codecNumber],
    ['end', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class ColumnRange extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ColumnRangeParser.decode(input).map(res => new ColumnRange(res));
    }
    static unsafeDecode(input) {
        return ColumnRange.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ColumnRangeParser.encode(data);
    }
    static schema() {
        return ColumnRangeParser.schema();
    }
}
